export default __webpack_public_path__ + "static/media/泰坦网络_white.d48b65d5.jpg";